"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialEditorProvider = void 0;
const multi_language_structure_warnings_provider_1 = require("./multi-language-structure-warnings.provider");
class MaterialEditorProvider {
}
exports.MaterialEditorProvider = MaterialEditorProvider;
MaterialEditorProvider.multiLanguageStructureWarning = {
    initialize: (onShow) => {
        multi_language_structure_warnings_provider_1.MultiLanguageStructureWarningProvider.mount(onShow);
    },
    destroy: () => {
        multi_language_structure_warnings_provider_1.MultiLanguageStructureWarningProvider.unmount();
    },
    confirm: () => {
        multi_language_structure_warnings_provider_1.MultiLanguageStructureWarningProvider.confirm();
    },
    cancel: () => {
        multi_language_structure_warnings_provider_1.MultiLanguageStructureWarningProvider.cancel();
    },
    getUserConfirmation: () => {
        return multi_language_structure_warnings_provider_1.MultiLanguageStructureWarningProvider.getUserConfirmation();
    }
};
